export default __webpack_public_path__ + "static/yellowstone-64cfa6b5e741c2813a9271b9b42b453f.jpg";